<template>
  <div>
    <PaymentIndex
      :pageTitle="$t('components.paymentManagement.headline')"
      :endpoint="getEndpoint"
      :fstId="`riderCredits_${getId}_`"
      :qso="getEndpointOptions"
    />
  </div>
</template>

<script>
import { useEndpoints } from '@/composables'
import PaymentIndex from '@/composites/transaction/payment/index/Index.vue'

export default {
  name: 'ViewRiderUserCreditTransactions',

  components: {
    PaymentIndex,
  },
  computed: {
    getId() {
      return this.$route.params.id
    },
    getEndpoint() {
      return useEndpoints.invoice.payments()
    },
    getEndpointOptions() {
      return {
        append: `&user=${this.$route.params.id}`,
        prepend: `?`,
      }
    },
  },
}
</script>
